import "../functions/PlayYoutubeVideo";
import "../functions/NewsTicker";

$(function () {
	$('.pg-p-customer-reviews').find('.pg-p-review-card-box__li').on('click',function(){
		
		var title = $(this).find('.c-text__review-text-title').text();
		var service = $(this).find('.c-text__review-text-service').text();
		var attribute = $(this).find('.c-text__review-text-attribute').text();
		var body = $(this).find('.c-text__review-text-body').text();
		var category = $(this).find(".c-text__review-text").data('category');
		var index = $(this).find(".c-text__review-text").data('index');
		var iconType = $(this).find(".c-text__review-text").data('icon');
		
		$('.pg-p-customer-reviews-modal').find('.modal-content-top-body-title').text(title);
		$('.pg-p-customer-reviews-modal').find('.modal-content-top-body-text-service').text(service);
		$('.pg-p-customer-reviews-modal').find('.modal-content-top-body-text-attribute').text(attribute);
		$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-body').text(body);
		
		$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').find('p').text(index);
		
		if(category != null){
			if(category == 1) {
				$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').css('background','#f35877');
				$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').removeClass('review-office');
				$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').addClass('review-private');
			} else {
				$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').css('background','#34b57d');
				$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').removeClass('review-private');
				$('.pg-p-customer-reviews-modal').find('.modal-content-top-voice').addClass('review-office');
			}
		} 
		
		if (iconType != null) {
			if(iconType == 1) {
				$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-img').css({'background-image':'url(/images/pages/index/illust_man.svg)', 'height':'140px','background-position':'unset'});
			} else if(iconType == 2) {
				$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-img').css({'background-image':'url(/images/pages/index/illust_old_man.svg)', 'height':'140px','background-position':'unset'});
			} else if(iconType == 3) {
				$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-img').css({'background-image':'url(/images/pages/index/illust_old_woman.svg)', 'height':'140px','background-position':'unset'});
			} else if(iconType == 4) {
				$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-img').css({'background-image':'url(/images/pages/index/illust_woman.svg)', 'height':'140px','background-position':'unset'});
			} else if(iconType == 5) {
				$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-img').css({'background-image':'url(/images/pages/index/illust_hojin.png)', 'height':'140px','background-position':'center'});
			}
		} else {
			$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-img').css({'background-image':'url(/images/pages/index/illust_man.svg)', 'height':'140px','background-position':'unset'});
		}		
		
		$('.pg-p-customer-reviews-modal').fadeIn();
        return false;
    });
	$('.pg-p-customer-reviews-modal').find('.pg-p-customer-reviews-modal-back').on('click',function(){
		$('.pg-p-customer-reviews-modal').fadeOut();
        return false;
    });
	
	$('.pg-p-customer-reviews-modal').find('.modal-content-bottom-close').find('span').on('click',function(){
		$('.pg-p-customer-reviews-modal').fadeOut();
        return false;
    });

	$('.slider').slick({
	    autoplay: false,         //自動再生
	    autoplaySpeed: 2000,　  //自動再生のスピード
	    speed: 800,     　 //スライドするスピード
	    dots: true,　　　　　　//スライドしたのドット
	    arrows: true,          //左右の矢印
	    infinite: true,　　　　//スライドのループ
	    pauseOnHover: false,   //ホバーしたときにスライドを一時停止しない　
	});
   $('.slider-sp-top').slick({
        autoplay: true,         //自動再生
        autoplaySpeed: 5000,　  //自動再生のスピード
        speed: 800,     　 //スライドするスピード
        dots: true,　　　　　　//スライドしたのドット
        arrows: true,          //左右の矢印
        infinite: true,　　　　//スライドのループ
        pauseOnHover: false,   //ホバーしたときにスライドを一時停止しない　
    });
	


	$(window).on('load',function(){
	//$(function(){
		//アイコン色を表示
		setTimeout(function(){
			$('#opening-animation').find('.start-screen').fadeOut();
		},0);
		//アイコンを縮小 
		setTimeout(function(){
			$('#opening-animation').find('.start-content').addClass('step1');
		},100);
		//ロゴテキストをスライドイン
		setTimeout(function(){
			$('#opening-animation').find('.start-content').addClass('step2');
		},1000);
		//アイコン・テキストロゴを中央に移動
		setTimeout(function(){
			$('#opening-animation').find('.start-content').addClass('step3');
		},1400);  
		//アイコンロゴの飛び出し
		setTimeout(function(){
			$('#opening-animation').find('.start-content').addClass('step4');
		},1800); 
		setTimeout(function(){
			$('#opening-animation').fadeOut(500);
		},2500); 
	});
});
